import { IFieldDisplayData } from "../../../../commonDataObjects/interfaces";
import { isWcmEditor } from "../../../../../config/serverConfig";
import { MultiAudioAutoBepoItemSlot } from "./multiAudioAutoBepoItem";
import { data } from "jquery";

interface AudioHeadlinesSiteComponentaProps{
  articles:any[]
   isMobileWeb:boolean 
    fieldsDisplaySettings:IFieldDisplayData
    numberOfVisibleItems:number
    hideVideoAds:boolean
    shouldAudioAutoplay?: boolean
}
export class MultiAudioAutoBepoSiteComponenta extends React.Component<AudioHeadlinesSiteComponentaProps,{}> {
 public static siteScriptName = "MultiAudioAutoBepoSiteComponenta";
    
 componentDidMount() {
       !this.props.isMobileWeb && !isWcmEditor() &&  this.syncHeightWithAudioBodyBepo();
    }

    private syncHeightWithAudioBodyBepo = () => {
        // Use setTimeout to ensure AudioBodyBepoComponent is fully rendered
        setTimeout(() => {
            const audioMultiAutoBepoComponent = document.querySelector('.multi-audio-auto-bepo-componenta') as HTMLElement;
            
            if (audioMultiAutoBepoComponent) {
                const setHeight = () => {
                    const audioMultiAutoBepoHeight = window.innerHeight - audioMultiAutoBepoComponent.getBoundingClientRect().top;
                    if (audioMultiAutoBepoHeight > 0) {
                        audioMultiAutoBepoComponent.style.height = `${audioMultiAutoBepoHeight}px`;
                    }
                };
                
                // Set initial height
                setHeight();
                
                // Create a ResizeObserver to monitor height changes
                if (window.ResizeObserver) {
                    const resizeObserver = new ResizeObserver(() => {
                        setHeight();
                    });
                    
                    resizeObserver.observe(audioMultiAutoBepoComponent);
                    (this as any)._resizeObserver = resizeObserver;
                }
                
                // Fallback: Also listen to window resize events
                const handleResize = () => setHeight();
                window.addEventListener('resize', handleResize);
                (this as any)._resizeHandler = handleResize;
                
            } else {
                console.warn('AudioBodyBepoComponent or multi-audio-auto-bepo-componenta not found');
                // Retry after a short delay
                setTimeout(() => this.syncHeightWithAudioBodyBepo(), 500);
            }
        }, 100);
    }
    
    componentWillUnmount() {
        // Clean up the ResizeObserver if it exists
        if ((this as any)._resizeObserver) {
            (this as any)._resizeObserver.disconnect();
        }
        
        // Clean up the resize event listener if it exists
        if ((this as any)._resizeHandler) {
            window.removeEventListener('resize', (this as any)._resizeHandler);
        }
    }



    render() {
        const { articles, isMobileWeb,  fieldsDisplaySettings, numberOfVisibleItems, hideVideoAds } = this.props
        let visibleItems = [];

            if (articles) {
                
                for (let i = 0; i < numberOfVisibleItems; i++) {
                    if (articles[i]) {
                        visibleItems.push(
                            <MultiAudioAutoBepoItemSlot
                                key={i}
                                item={articles[i]}
                                isMobileWeb={isMobileWeb}
                                shouldAudioAutoplay={i === 0 ? this.props.shouldAudioAutoplay : false}
                                fieldsDisplaySettings={fieldsDisplaySettings}
                                isAudioPlaeyrEnabled={i===0}
                                hideVideoAds={hideVideoAds}
                            />
                        )
                    }
                }
            }
        
        return (
            <div className="multi-audio-auto-bepo-componenta">             
                    {visibleItems}
            </div>
        )
    }
}